import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackPatientRegistrationView = (userId?: string): void => {
  trackingService.trackEvent(
    'REGISTER',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '/inicio/cadastro-completo-paciente',
      placement: '',
      surface: '',
      flow: 'cadastro paciente',
      step: 'dados pessoais',
      element: '',
      action: 'view',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientSaveNewClick = (userId?: string): void => {
  trackingService.trackEvent(
    'SAVE',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro paciente',
      step: 'salvar paciente',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientSaveEditClick = (userId?: string): void => {
  trackingService.trackEvent(
    'SAVE',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro paciente',
      step: 'atualizar cadastro',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientRegistrationBackClick = (userId?: string): void => {
  trackingService.trackEvent(
    'BACK',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'header',
      surface: '',
      flow: 'cadastro paciente',
      step: 'voltar para inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientExistsDialogBackClick = (userId?: string): void => {
  trackingService.trackEvent(
    'BACK',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'cadastro paciente',
      step: 'paciente existente',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientExistsDialogCheckClick = (userId?: string): void => {
  trackingService.trackEvent(
    'CHECK',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'cadastro paciente',
      step: 'paciente existente',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackInitPrescriptionDialogNoClick = (userId?: string): void => {
  trackingService.trackEvent(
    'NO',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'cadastro paciente',
      step: 'continuar cadastro',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackInitPrescriptionDialogYesClick = (userId?: string): void => {
  trackingService.trackEvent(
    'YES',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'prescrever',
      step: 'ir para prescrição',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientTabBasicDataClick = (userId?: string): void => {
  trackingService.trackEvent(
    'PACIENT_INFO',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'menu',
      surface: 'list',
      flow: 'cadastro paciente',
      step: 'continuar cadastro',
      element: 'tab',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientTabAdditionalDataClick = (userId?: string): void => {
  trackingService.trackEvent(
    'PACIENT_INFO',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'menu',
      surface: 'list',
      flow: 'cadastro paciente',
      step: 'adicionais e endereço',
      element: 'tab',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientTabClinicalDataClick = (userId?: string): void => {
  trackingService.trackEvent(
    'PACIENT_INFO',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'menu',
      surface: 'list',
      flow: 'cadastro paciente',
      step: 'dados clínicos',
      element: 'tab',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientAdditionalDataView = (userId?: string): void => {
  trackingService.trackEvent(
    'REGISTER',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: '',
      surface: '',
      flow: 'cadastro paciente',
      step: 'dados adicionais e endereço',
      element: '',
      action: 'view',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientAdditionalDataWhatsMyCepClick = (userId?: string): void => {
  trackingService.trackEvent(
    'WHATS_MY_CEP',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro paciente',
      step: 'dados adicionais e endereço',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientAdditionalDataSaveClick = (userId?: string): void => {
  trackingService.trackEvent(
    'SAVE',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro paciente',
      step: 'salvar dados adicionais',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientClinicalDataView = (userId?: string): void => {
  trackingService.trackEvent(
    'REGISTER',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: '',
      surface: '',
      flow: 'cadastro paciente',
      step: 'dados clínicos',
      element: '',
      action: 'view',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientClinicalDataSaveClick = (userId?: string): void => {
  trackingService.trackEvent(
    'SAVE',
    PRODUCT_NAME,
    {
      page: 'cadastro paciente',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro paciente',
      step: 'salvar dados clínicos',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
